<!-- コミッション（コミッションコード適用時）の内訳行 -->
<template>
  <div class="inline-flex items-end justify-start gap-2 self-stretch">
    <div class="flex-1 justify-start font-Spectral text-sm font-light leading-tight text-light-fg-muted">Commission ({{ benefitValue }}% on pre-tax)</div>
    <div class="justify-start text-right font-Spectral text-sm font-normal leading-tight text-light-fg-muted" data-testid="commissionAmount">- {{ commissionDisplay }}</div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  /** コミッション率（%） */
  benefitValue?: number;
  /** コミッション額（表示用文字列） */
  commissionDisplay: string;
}

defineProps<Props>();
</script>
